"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityServicesRebalanced = void 0;
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var Resources_1 = require("../../../Resources");
var Card_1 = require("../../Card");
var CardRenderer_1 = require("../../render/CardRenderer");
var CommunityServicesRebalanced = (function (_super) {
    __extends(CommunityServicesRebalanced, _super);
    function CommunityServicesRebalanced() {
        return _super.call(this, {
            cost: 11,
            name: CardName_1.CardName.COMMUNITY_SERVICES_REBALANCED,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                cardNumber: 'C04',
                description: 'Increase your M€ production 1 step per CARD WITH NO TAGS, including this.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) {
                        pb.megacredits(1);
                    }).slash().noTags();
                }),
                victoryPoints: 1,
            },
        }) || this;
    }
    CommunityServicesRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, player.getNoTagsCount() + 1, { log: true });
        return undefined;
    };
    CommunityServicesRebalanced.prototype.getVictoryPoints = function () {
        return 1;
    };
    return CommunityServicesRebalanced;
}(Card_1.Card));
exports.CommunityServicesRebalanced = CommunityServicesRebalanced;
//# sourceMappingURL=CommunityServicesRebalanced.js.map